<template>
  <basic-container class="navigation-config-page">
    <div class="page-header">
      <div class="filter-container">
            <div class="filter-box">
                <el-input class="filter-item" v-model="filter.navgationTitle" placeholder="导航标题&备注" clearable @clear="returnFirstPage"></el-input>
                <el-select class="filter-item" v-model="filter.pageTypeId" filterable placeholder="关联页面" clearable @clear="returnFirstPage">
                    <el-option
                    v-for="item in pageTypeOptions"
                    :key="item.id"
                    :label="`(${item.id}) ${item.pageName}`"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select class="filter-item" v-model="filter.status" filterable placeholder="状态" clearable @clear="returnFirstPage">
                    <el-option label="生效" :value="1"/>
                    <el-option label="失效" :value="0"/>
                </el-select>
            </div>
            <div class="button-container">
                <el-button type="primary" @click="returnFirstPage">搜索</el-button>
                <el-button type="primary" plain @click="addNavigation">新增</el-button>
            </div>
        </div>
    </div>
    <el-table
        v-loading="isLoading"
        class="config-table"
        :data="navigationList"
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID" fixed="left"></el-table-column>
        <el-table-column prop="navgationTitle" label="导航标题"></el-table-column>
        <el-table-column label="选中icon" width="121">
          <template slot-scope="{row}">
            <el-image
              v-if="row.onicon"
              class="table-img"
              :src="row.onicon"
              :preview-src-list="[row.onicon]"
              fit="contain"
              >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="未选中icon" width="121">
          <template slot-scope="{row}">
            <el-image
              v-if="row.inicon"
              class="table-img"
              :src="row.inicon"
              :preview-src-list="[row.inicon]"
              fit="contain"
              >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="关联页面">
          <template slot-scope="{row}">
            <el-tag>{{ `(${row.pageTypeId}) ${row.pageTypeName}` }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="navgationId" label="导航ID">
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="状态">
            <template slot-scope="{row}">
                <div>{{ statusMap[row.status] }}</div>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="{row}">
                <el-button type="text" size="small" @click="editNavigation(row)">编辑</el-button>
                <el-button type="text" size="small" @click="deleteNavigation(row)">删除</el-button>
                <el-button type="text" size="small" @click="viewLog(row)">日志</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="pagination-container">
        <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="limit"
            :total="total">
        </el-pagination>
    </div>
    <!-- 新增&编辑对话框 -->
    <EditNavigationDialog v-model="editNavigationDialogIsShow" :editType="editType" :confirmCallback="refreshNavigationList" :selectNavigation="selectNavigation"/>
    <!-- 操作日志 -->
    <LogDialog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadLog" :closeBtn="false">
        <template #type="{ row }">
          <div>
            <!-- 操作类型(1-新增, 2-修改, 3-删除 -->
            <span v-if="row.type === 1">新增</span>
            <span v-if="row.type === 2">修改</span>
            <span v-if="row.type === 3">删除</span>
            <span v-if="row.type === 4">提交审核</span>
            <span v-if="row.type === 5">撤销审核</span>
            <span v-if="row.type === 6">审核通过</span>
            <span v-if="row.type === 7">审核拒绝</span>
          </div>
        </template>
      </LogDialog>
  </basic-container>
</template>

<script>
import { statusMap } from '../const/common'
import LogDialog from '@/components/OptionsLog/optionLog.vue'
import EditNavigationDialog from './components/editNavigationDialog.vue'
import { list, deleteNavigation } from '@/api/tv/navigation'
import { page } from '@/api/tv/pageType';
import { getLogList } from '@/api/tv/log'
import { cloneDeep } from 'lodash'
export default {
  name: 'MyComponent',
  components: { LogDialog, EditNavigationDialog },
  props: {},
  data() {
    return {
      statusMap,
      filter: {
        navgationTitle: '', //导航标题
        pageTypeId: null, //关联页面
        status: null, //状态
      },//筛选条件
      navigationList: [], //导航列表
      page: 1,
      limit: 10,
      total: 0,
      isLoading: false, //是否加载中
      editNavigationDialogIsShow: false, //新增&编辑对话框是否展示
      editType: 1, //编辑类型，1新增 2编辑
      selectNavigation: null, //选择的导航
      /** 操作日志配置列 */
      optionLogColumn: [
          {
          prop: "operateTime",
          label: "操作时间",
          },
          {
          prop: "operator",
          label: "操作人",
          },
          {
          prop: "type",
          label: "操作类型",
          slot: "type",
          },
      ],
      pageTypeOptions: [], //页面类型可选项
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 刷新页面类型选项
    async refreshPageTypeOptions() {
      const {data: {data: {records}}} = await page({
        current: 1,
        size: 10000,
      })
      this.pageTypeOptions = records
    },
    handleSizeChange(size) {
      this.limit = size;
      this.refreshNavigationList()
    },
    handleCurrentChange(page) {
      this.page = page;
      this.refreshNavigationList()
    },
    // 刷新导航列表
    async refreshNavigationList() {
      try{
        this.isLoading = true;
        this.navigationList = []
        const {data: {data: {records, total}}} = await list({
          current: this.page,
          size: this.limit,
          navgationTitle: this.filter.navgationTitle,
          pageTypeId: this.filter.pageTypeId,
          status: this.filter.status,
        })
        this.navigationList = records
        this.total = total
      }finally{
        this.isLoading = false;
      }
    },
    // 返回第一页
    returnFirstPage() {
      this.page = 1;
      this.refreshNavigationList();
    },
    // 新增导航
    addNavigation() {
        this.editType = 1;
        this.editNavigationDialogIsShow = true;
    },
    // 编辑导航
    editNavigation(row) {
        this.selectNavigation = row;
        this.editType = 2;
        this.editNavigationDialogIsShow = true;
    },
    //删除导航
    async deleteNavigation(row) {
      this.$confirm('是否确定删除该导航?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteNavigation({id: row.id})
        this.$message.success('删除成功')
        this.refreshNavigationList()
      })
    },
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      try {
        const optSearch = this.$refs.optionLog.searchParams;
        const { data } = await getLogList({
          ...optSearch,
          subjectId: row.id,
          module: 'TV_NAVIGATION'
        });
        console.log("查看日志的响应", data, optSearch);
        const list = cloneDeep(data.data.records);
        optSearch.total = data.data.total || 0
        this.$refs.optionLog.show(
          list,
          row.id
        );
      } catch (error) {
        console.log("查看日志失败", error);
      }
    },
    /** 日志分页 */
    async reloadLog(id) {
      console.log("日志分页", id);
      try {
        const optSearch = this.$refs.optionLog.searchParams;
        const { data } = await getLogList({
          ...optSearch,
          subjectId: id,
          module: 'TV_NAVIGATION'
        });
        console.log("查看日志的响应", data);
        const list = cloneDeep(data.data.records);
        this.$refs.optionLog.list = list;
        this.$refs.optionLog.searchParams.total = data.data.total;
      } catch (error) {
        console.log("日志分页失败", error);
      }
    },
  },
  created() {},
  mounted() {
    this.refreshPageTypeOptions()
    this.refreshNavigationList()
  }
}
</script>

<style scoped>
.navigation-config-page{
  margin-bottom: 20px;
  .filter-container{
        display: flex;
        flex-wrap: wrap;
        .filter-box{
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            .filter-item{
                width: 200px;
                margin-right: 16px;
                margin-bottom: 16px;
            }
        }
        .button-container{
            width: fit-content;
            margin-left: auto;
            margin-bottom: 16px;
        }
    }
    .config-table{
        margin-bottom: 16px;
        .table-img{
          width: 100px;
          height: 66px;
        }
    }
    .pagination-container{
        display: flex;
        justify-content: end;
    }
}
</style>